// src/payments/TokenModal.jsx
import { useState } from "react";
import { useAuth }  from "../auth/AuthGate";
import { TIERS }    from "./tiers";

export default function TokenModal({ onClose, currentBalance }) {
  const { getToken } = useAuth();
  const [loadingTier, setLoadingTier] = useState(null);
  const [error, setError]             = useState("");

  const purchase = async (tier) => {
    setError("");
    setLoadingTier(tier.tokens);
    try {
      const res  = await fetch("/.netlify/functions/wc-create-checkout", {
        method:  "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        body:    JSON.stringify({ tier: tier.tier }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Checkout failed");
      window.location.href = data.url;
    } catch (e) {
      setError(e.message);
      setLoadingTier(null);
    }
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={e => e.stopPropagation()}>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
          <div>
            <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 22, fontWeight: 400, color: "#e6edf3", margin: 0 }}>Buy Tokens</h2>
            <p style={{ color: "#8b949e", fontSize: 13, margin: "4px 0 0" }}>1 token = 1 evaluation · Tokens never expire · Shared across all apps</p>
          </div>
          <button onClick={onClose} style={closeBtnStyle}>✕</button>
        </div>

        {currentBalance !== null && (
          <div style={{ fontSize: 12, color: "#8b949e", marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #21262d" }}>
            Current balance:{" "}
            <span style={{ color: currentBalance === 0 ? "#f85149" : "#4ade80", fontWeight: 700 }}>
              {currentBalance} {currentBalance === 1 ? "token" : "tokens"}
            </span>
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
          {TIERS.map(tier => (
            <div key={tier.tokens} style={{
              border:       `1px solid ${tier.highlight ? "#388bfd" : "#30363d"}`,
              borderRadius: 12, padding: 16, position: "relative",
              background:   tier.highlight ? "rgba(56,139,253,0.08)" : "#0d1117",
            }}>
              {tier.highlight && (
                <div style={{ position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)", background: "#388bfd", color: "#fff", fontSize: 10, fontWeight: 700, padding: "3px 10px", borderRadius: 99, whiteSpace: "nowrap" }}>
                  MOST POPULAR
                </div>
              )}
              <div style={{ fontSize: 11, fontWeight: 700, color: "#8b949e", letterSpacing: 1, textTransform: "uppercase", marginBottom: 4 }}>{tier.label}</div>
              <div style={{ fontSize: 26, fontWeight: 700, color: "#e6edf3", lineHeight: 1 }}>
                {tier.tokens}<span style={{ fontSize: 13, color: "#8b949e", fontWeight: 400 }}> tokens</span>
              </div>
              <div style={{ fontSize: 18, fontWeight: 700, color: "#388bfd", margin: "6px 0 4px" }}>{tier.price}</div>
              <div style={{ fontSize: 11, color: "#8b949e", marginBottom: 12 }}>{tier.desc}</div>
              <button
                onClick={() => purchase(tier)}
                disabled={loadingTier !== null}
                style={{
                  width: "100%", padding: "8px", borderRadius: 8,
                  fontSize: 13, fontWeight: 700, border: "none",
                  cursor: loadingTier !== null ? "not-allowed" : "pointer",
                  background: tier.highlight && loadingTier !== tier.tokens ? "linear-gradient(135deg, #1f6feb, #388bfd)" : "#21262d",
                  color: loadingTier !== null ? "#484f58" : "#fff",
                  fontFamily: "'DM Sans', sans-serif",
                }}>
                {loadingTier === tier.tokens ? "Redirecting…" : `Buy ${tier.tokens} Tokens`}
              </button>
            </div>
          ))}
        </div>

        {error && (
          <div style={{ background: "rgba(248,81,73,0.1)", border: "1px solid #f85149", borderRadius: 8, padding: "10px 14px", color: "#f85149", fontSize: 13, marginBottom: 10 }}>
            ⚠ {error}
          </div>
        )}
        <p style={{ fontSize: 11, color: "#484f58", textAlign: "center", margin: 0, lineHeight: 1.6 }}>
          Secure payment via Stripe. Tokens are shared across Writing Coach, SSE, and Reading Comp Buddy.
        </p>
      </div>
    </div>
  );
}

const overlayStyle = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 200, padding: 20 };
const modalStyle   = { width: "100%", maxWidth: 520, background: "#161b22", border: "1px solid #30363d", borderRadius: 16, padding: 28, fontFamily: "'DM Sans', sans-serif" };
const closeBtnStyle = { background: "transparent", border: "1px solid #30363d", color: "#8b949e", borderRadius: 7, width: 32, height: 32, cursor: "pointer", fontSize: 16 };
